import util from '../util';

export const DEALER_DATA_REVISIONS = 'DEALER_DATA_REVISIONS';

export const DEALER_DATA_REVISIONS_REQUEST = util.requestType(
  DEALER_DATA_REVISIONS,
);
export const DEALER_DATA_REVISIONS_SUCCESS = util.successType(
  DEALER_DATA_REVISIONS,
);
export const DEALER_DATA_REVISIONS_FAILURE = util.failureType(
  DEALER_DATA_REVISIONS,
);
